module.exports = __webpack_public_path__ + "img/remove_shopping_cart_black_48dp.a6625c34.svg";